import React from 'react';
import { ContainerBackgroundColor } from '@extensions/AttributePanel/components/attributes/ContainerBackgroundColor';
import { Padding } from '@extensions/AttributePanel/components/attributes/Padding';
import { Grid, Collapse } from '@arco-design/web-react';
import { ClassName } from '../../attributes/ClassName';
import { CollapseWrapper } from '../../attributes/CollapseWrapper';
import { t } from '@bay-email/core';
import { pixelAdapter } from '../../adapter';
import { useFocusIdx } from '@bay-email/editor';
import { InputWithUnitField } from '@extensions/components/Form';

export function Spacer() {
	const { focusIdx } = useFocusIdx();

	return (
		<CollapseWrapper
			isChevron
			iconPosition='right'
			defaultActiveKey={['1', '2']}
			style={{ padding: 0 }}
		>
			<Collapse.Item
				name='1'
				header={t('Dimension')}
				contentStyle={{ padding: 0 }}
			>
				<div className='p-3'>
					<Grid.Row
						gutter={16}
						style={{ marginBottom: '16px' }}
					>
						<Grid.Col span={12}>
							<div style={{ paddingRight: '8px' }}>
								<InputWithUnitField
									label={`${t('Height')} (px)`}
									name={`${focusIdx}.attributes.height`}
									config={pixelAdapter}
									placeholder='20'
								/>
							</div>
						</Grid.Col>
					</Grid.Row>
					<Padding />
				</div>
			</Collapse.Item>

			<Collapse.Item
				name='2'
				header={t('Styling')}
				contentStyle={{ padding: 0 }}
			>
				<div className='p-3'>
					<Grid.Row gutter={16}>
						<Grid.Col span={12}>
							<ContainerBackgroundColor title={t('Background color')} />
						</Grid.Col>
					</Grid.Row>
				</div>
			</Collapse.Item>

			<Collapse.Item
				name='4'
				header={t('Extra')}
				contentStyle={{ padding: 0 }}
			>
				<div className='p-3'>
					<ClassName />
				</div>
			</Collapse.Item>
		</CollapseWrapper>
	);
}
